import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom";
import {
  SignIn,
  LoginAuthToken,
  SignInWithAzure,
} from "../../ReduxStore/Slice/Auth/authSlice";
import { useDispatch } from "react-redux";
import { azureLogin } from "../AuthWithAzure/AuthProvider";
import { Email_regex, Mobile_regex } from "../../Utils/Common_regex";
import { base_url } from "../../Utils/Config";
import {
  PASSWORD_ERROR,
  INVALID_EMAIL_ERROR,
  EMPTY_EMAIL_ERROR,
} from "../../Utils/Common_Message";
import { RoleAccess } from "../../ReduxStore/Slice/Access/AccessSlice";
import sweatalert from "sweetalert2";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPassword, setErrorPassword] = useState("");

 console.log("base_url", base_url);

  const handleSubmitLogin = async () => {
    if (Email == "") {
      setErrorEmail(EMPTY_EMAIL_ERROR);
      return;
    } else if (!Email_regex(Email)) {
      setErrorEmail(INVALID_EMAIL_ERROR);
      return;
    }

    if (password == "") {
      setErrorPassword(PASSWORD_ERROR);
      return;
    }

    const req = { email: Email, password: password };

    await dispatch(SignIn(req))
      .unwrap()
      .then(async (response) => {
        if (response.status) {
          await accessDataFetch(response.data.staffDetails, response.data.token);
          localStorage.setItem(
            "staffDetails",
            JSON.stringify(response.data.staffDetails)
          );
          localStorage.setItem("token", JSON.stringify(response.data.token));
          localStorage.setItem("sharepoint_token", JSON.stringify(response.data.sharepoint_token));
          localStorage.setItem(
            "role",
            JSON.stringify(response.data.staffDetails.role)
          );

          // sweet alert
          sweatalert.fire({
            title: "Login Successfully",
            icon: "success",
            timer: 1000,
            showConfirmButton: false,
            timerProgressBar: true,
          });


          const req_auth_token = {
            id: response.data.staffDetails.id,
            login_auth_token: response.data.token,
          };
          await dispatch(LoginAuthToken(req_auth_token))
            .unwrap()
            .then(async (response) => { })
            .catch((error) => {
              return;
            });
          setTimeout(() => {
            navigate("/admin/dashboard");
            window.location.reload();
          }, 1000);

        } else {
          localStorage.removeItem("staffDetails");
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          localStorage.removeItem("accessData");
          localStorage.removeItem("updatedShowTab");
          sessionStorage.clear();
          sweatalert.fire({
            title: response.message,
            icon: "error",
            timer: 1000,
            showConfirmButton: true,
            timerProgressBar: true,
          });
        }
        //continue....
      })
      .catch((error) => {
        return;
      });
  };

  const handleAzureLogin = async () => {
    console.log("Azure Login");
    const accounts = await azureLogin();
    console.log("Azure Accounts", accounts);
//    console.log("Azure Accounts", accounts);
    if (accounts.length > 0) {
      const req = { email: accounts[0].username };

      await dispatch(SignInWithAzure(req))
        .unwrap()
        .then(async (response) => {
          if (response.status) {

            await accessDataFetch(response.data.staffDetails, response.data.token);
            
            localStorage.setItem(
              "staffDetails",
              JSON.stringify(response.data.staffDetails)
            );
            localStorage.setItem("token", JSON.stringify(response.data.token));
            localStorage.setItem("sharepoint_token", JSON.stringify(response.data.sharepoint_token));
            localStorage.setItem(
              "role",
              JSON.stringify(response.data.staffDetails.role)
            );

            //Update Auth Token
            const req_auth_token = {
              id: response.data.staffDetails.id,
              login_auth_token: response.data.token,
            };
            await dispatch(LoginAuthToken(req_auth_token))
              .unwrap()
              .then(async (response) => { })
              .catch((error) => {
                return;
              });

            navigate("/admin/dashboard");
            window.location.reload();
          } else {
            sweatalert.fire({
              title: response.message,
              icon: "error",
              timer: 1000,
              showConfirmButton: true,
              timerProgressBar: true,
            });

            localStorage.removeItem("staffDetails");
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            sessionStorage.clear();
            
          }
        })
        .catch((error) => {
          return;
        });
    }
  };

  const accessDataFetch = async (data, token) => {
    try {
      const response = await dispatch(
        RoleAccess({
          req: { role_id: data.role_id, StaffUserId: data.id, action: "get" },
          authToken: token,
        })
      ).unwrap();

      if (response.data) {

        localStorage.setItem("accessData", JSON.stringify(response.data));

        response.data.forEach((item) => {
          const updatedShowTab = {
            setting: false,
            customer: false,
            staff: false,
            status: false,
            report: false,
            timesheet: false,
            job: false,
            client: false,
            all_customers: false,
            all_clients: false,
            all_jobs: false,

          };

          response.data.forEach((item) => {
            if (item.permission_name === "setting") {
              const settingView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.setting =
                settingView && settingView.is_assigned === 1;
            } else if (item.permission_name === "customer") {
              const customerView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.customer =
                customerView && customerView.is_assigned === 1;
            } else if (item.permission_name === "staff") {
              const staffView = item.items.find((item) => item.type === "view");
              updatedShowTab.staff = staffView && staffView.is_assigned === 1;
            } else if (item.permission_name === "status") {
              const statusView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.status =
                statusView && statusView.is_assigned === 1;
            }else if (item.permission_name === "timesheet") {
              const timesheetView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.timesheet =
                timesheetView && timesheetView.is_assigned === 1;
            }
            else if (item.permission_name === "job") {
              const jobView = item.items.find((item) => item.type === "view");
              updatedShowTab.job = jobView && jobView.is_assigned === 1;
            } else if (item.permission_name === "client") {
              const clientView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.client =
                clientView && clientView.is_assigned === 1;
            }
            else if (item.permission_name === "report") {
              const reportView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.report =
              reportView && reportView.is_assigned === 1;
            }
              
            else if (item.permission_name === "all_customers") {
              const allCustomerView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.all_customers =
                allCustomerView && allCustomerView.is_assigned === 1;
            }
            else if (item.permission_name === "all_clients") {
              const allClientView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.all_clients =
                allClientView && allClientView.is_assigned === 1;
            }
            else if (item.permission_name === "all_jobs") {
              const allJobsView = item.items.find(
                (item) => item.type === "view"
              );
              updatedShowTab.all_jobs =
                allJobsView && allJobsView.is_assigned === 1;
            }
          });
          
          localStorage.setItem("updatedShowTab",JSON.stringify(updatedShowTab));
        });
      }
    } catch (error) {
      return;
    }
  };


  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmitLogin();
    }
  }

  return (
    <div className="account-body accountbg">
      <div className="container">
        <div className="row  d-flex justify-content-center vh-100">
 {/*  Login  Microsoft only*/}

         <div className="col-10 col-md-9 col-lg-9 align-self-center form-container">
            <div className="row " style={{ height: "300px" }}>
              <div className="col-md-6 px-0">
                <div className="card-body p-0 auth-header-box  h-100 d-flex align-items-center justify-content-center">
                  <div className="text-center p-3">
                    <a className="logo logo-admin" href="/">
                      <img
                        src="assets/images/logo.png"
                        alt="logo"
                        style={{ height: "55px" }}
                        className="auth-logo"
                      />
                    </a>
                    
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex flex-column justify-content-center h-100 py-5 px-3">
                  <div className="card-header text-center">
                  <h3 className="mt-3 mb-1 font-weight-semibold px-5" style={{lineHeight:"35px"}}>
                      Let's Get Started Outbooks
                    </h3>
                  </div>
                  <div className="card-body">
                    <div
                      className="form-horizontal auth-form my-4"
                      action="https://mannatthemes.com/dastyle/default/index.html"
                    >
                     
                      </div>
                    <button
                      type="button"
                      className="btn d-block mx-auto btn-outline-info login-microsoft w-100"
                      onClick={() => handleAzureLogin()}
                    >
                      <img
                        src="/assets/images/brand-logo/Microsoft_365.webp"
                        className="me-2"
                      ></img>{" "}
                      Login with Microsoft
                    </button>
                  </div>
                </div>
              </div>
              
            </div>
           
          </div>




         {/*  Login  with Email and Password*/}
 
        {/* <div className="col-10 col-md-12 col-lg-9 align-self-center form-container">
            <div className="row ">
              <div className="col-md-6 ps-0">
                <div className="card-body p-0 auth-header-box h-100 d-flex align-items-center justify-content-center">
                  <div className="text-center p-3">
                    <a className="logo logo-admin" href="/">
                      <img
                        src="assets/images/logo.png"
                        alt="logo"
                        style={{ height: "55px" }}
                        className="auth-logo"
                      />
                    </a>
                    <h4 className="mt-3 mb-1 font-weight-semibold text-white font-18">
                      Let's Get Started Outbooks
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="py-5 px-3">
                  <div className="card-header text-center">
                    <h1 className="">Sign In</h1>
                  </div>
                  <div className="card-body">
                    <div
                      className="form-horizontal auth-form my-4"
                      action="https://mannatthemes.com/dastyle/default/index.html"
                    >
                      <div className="form-group mb-2">
                   

                        <div className="input-group ">
                          <input
                            type="email"
                            className={errorEmail ? "error-field form-control" : "form-control"}
                            name="username"
                            id="username"
                            placeholder="Enter Email Id"
                            onChange={(e) => setEmail(e.target.value)}
                            value={Email}
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                        {errorEmail ? (
                          <span className="error-text">{errorEmail}</span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form-group">
                      
                        <div className="input-group ">
                          <input
                            type="password"
                            className={errorPassword ?  "error-field form-control" : "form-control"}

                            name="password"
                            id="userpassword"
                            placeholder="Enter password"
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                        {errorPassword ? (
                          <span className="error-text"> {errorPassword}</span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form-group row my-2 text-center">
                        <div className="col-sm-12 ">
                        
                        </div>
                      
                      </div>
                      <div className="form-group mb-0 row text-center">
                        <div className="col-12 mt-2">
                          <button
                            className="w-100 btn btn-info fw-normal text-white "
                            type="button"
                            onClick={() => handleSubmitLogin()}
                            onKeyPress={handleKeyPress}
                          >
                            Sign In <i className="fas fa-sign-in-alt ml-1" />
                          </button>
                        </div>
                     
                      </div>
                    </div>
                  
                    <div className="account-social">
                      <h6 className="my-4">OR </h6>
                    </div>

                    <button
                      type="button"
                      className="btn d-block mx-auto btn-outline-info login-microsoft"
                      onClick={() => handleAzureLogin()}
                    >
                      <img
                        src="/assets/images/brand-logo/Microsoft_365.webp"
                        className="me-2"
                      ></img>{" "}
                      Login with Microsoft
                    </button>
                  </div>
                </div>
              </div>
            
            </div>
            
          </div>   */}


         
        </div>
      </div>
      {/* <div className="container" id="container">
    <div className="form-container sign-up">
      <form>
        <h1>Create Account</h1>
        <div className="social-icons">
          <a href="#" className="icons"><i className="fa-brands fa-google-plus-g" /></a>
          <a href="#" className="icons"><i className="fa-brands fa-facebook-f" /></a>
          <a href="#" className="icons"><i className="fa-brands fa-github" /></a>
          <a href="#" className="icons"><i className="fa-brands fa-linkedin-in" /></a>
        </div>
        <span>or use your email to registration</span>
        <input type="text" placeholder="Name" />
        <input type="email" placeholder="Email" />
        <input type="password" placeholder="Password" />
        <button>Sign Up</button>
      </form>
    </div>
    <div className="form-container sign-in">
      <form>
        <h1>Sign In</h1>
        <div className="social-icons">
          <a href="#" className="icons"><i className="fa-brands fa-google-plus-g" /></a>
          <a href="#" className="icons"><i className="fa-brands fa-facebook-f" /></a>
          <a href="#" className="icons"><i className="fa-brands fa-github" /></a>
          <a href="#" className="icons"><i className="fa-brands fa-linkedin-in" /></a>
        </div>
        <span>or use your email/password</span>
        <input type="email" placeholder="Email" />
        <input type="password" placeholder="Password" />
        <a href="#">Forget your Password?</a>
        <button className='btn btn-info text-white fw-normal'>Sign In</button>
      </form>
    </div>
    <div className="toggle-container">
      <div className="toggle row align-items-center mx-auto">
        <div className="toggle-panel col-md-6">
          <h1>Welcome Back!</h1>
          <p>Enter your Personal details to use all_of site features</p>
          <button className="hidden" id="login">Sign In</button>
        </div>
        <div className="toggle-panel  col-md-6">
        <img src="assets/images/outbooks-logo-wide.svg" alt="logo" className="auth-logo" />
          <p>Let's Get Started
          Outbooks</p>
          
        </div>
      </div>
    </div>
  </div> */}
  <Link to="/login1" className="mt-3 login1 " style={{width:'50px' , fontSize:"50px",textDecoration:'none'}}>*</Link>
    </div>
  );
};

export default Login;
